import { IntlMessageFormat as l } from "./index45.mjs";
import { useCallback as u } from "react";
const f = (s, a, n) => (r, i) => {
  if (r === void 0) return "";
  const e = a(r);
  if (n && (r = n(r)), !e)
    return console.warn(
      `Can't find namespace. Make sure you pass all used namespaces in the getBaseServerSideProps. Some troubles with "${r}"`
    ), "";
  for (let t of e) {
    const o = s(r, { ns: t, ...i });
    if (o && o !== r) return o;
  }
  return r;
}, g = (s, a, n) => (r, i, e) => {
  const t = f(s, a, n);
  try {
    const o = t(r, e);
    if (!o) return "";
    const c = new l(o).format(i);
    return Array.isArray(c) ? c.join("") : c;
  } catch (o) {
    return console.error(`tICU formatting error for key "${r}":`, o), "";
  }
}, p = ({
  useTranslation: s,
  defaultNamespaces: a,
  namespaceMapper: n,
  assetKeyMapper: r
}) => function(e = []) {
  const { t, ...o } = s([...a, ...e]), m = u(f(t, n, r), [t]), c = u(g(t, n, r), [
    t
  ]);
  return { t: m, tICU: c, ...o };
};
export {
  f as getTFuncWithNamespace,
  g as getTICUFuncWithNamespace,
  p as getUseLocoTranslation
};
